<!-- VEHICLE SWITCHER -->
<div class="control mt-0" *ngIf="(vm$ | async) as vm">
  <div class="vehicle-title-cta">

    <!-- ACTIVE VEHICLE YMM -->
    <div *ngIf="vm.activeVehicle" class="gb-descriptive2 gb-color-grey-mid-dark">
      <p>{{vm.activeVehicle.year}} {{make}} {{model}}</p>
    </div>

    <!-- VEHICLE SWITCHER BUTTON -->
    <button *ngIf="vm.garage.length > 1"  href="#" class="gb-secondary-button-inline-icon icon-right p-3" (click)="openVPModal()">
      {{ 'switchVehicle_modal_toggle' | translate }}
      <svg
        version="1.1"
        id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18.9 13.2"
        style="enable-background:new 0 0 18.9 13.2;"
        xml:space="preserve">
        <g fill="currentColor">
          <path class="st0" d="M14.5,7.7c-0.3,0-0.6-0.1-0.8-0.4C13.3,7,13.4,6.3,13.8,6l1.3-1.1l-5.4,0c0,0,0,0,0,0c-0.6,0-1-0.4-1-1s0.4-1,1-1l5.4,0l-1.3-1.1c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l3.4,2.9c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.3,0.1,0.4c0,0,0,0,0,0c0,0.3-0.1,0.6-0.4,0.8l-3.4,2.8C14.9,7.7,14.7,7.7,14.5,7.7z" /><g>
          <path class="st0" d="M4.4,13.2c-0.2,0-0.5-0.1-0.6-0.2l-3.4-2.8C0.1,9.9,0,9.6,0,9.3c0,0,0,0,0,0C0,9.2,0,9,0.1,8.9c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0,0,0,0l3.4-2.9c0.4-0.4,1.1-0.3,1.4,0.1c0.4,0.4,0.3,1.1-0.1,1.4L3.7,8.3l5.4,0c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1c0,0,0,0,0,0l-5.4,0L5,11.4c0.4,0.4,0.5,1,0.1,1.4C5,13.1,4.7,13.2,4.4,13.2z" /></g>
        </g>
      </svg>
    </button>
  </div>

  <!-- ACTIVE VEHICLE IMAGE -->
  <div *ngIf="vm.activeVehicle && vm.garage.length > 0" class="vehicle-thumb">
    <ox-ghost-image [srcUrl]="vm.activeVehicle.renderImageUrl" altText="{{vm.activeVehicle.year}} {{vm.activeVehicle.make}} {{vm.activeVehicle.model}}"></ox-ghost-image>
  </div>

  <!-- VEHICLE SWITCHER MODAL-->
  <ox-general-modal *ngIf="vm.garage"
    [(show)]="showVPModal"
    [options]="vpModalStyling"
    [bodyComponent]="vehiclePicker"
    [bindingInputs]="{garage: vm.garage, activeVehicle$: activeVehicle$, isModalClosable: isModalClosable}"
    [bindingOutputs]="vpOutputs">
  </ox-general-modal>
</div>
